export enum UserAccessType {
    Unknown,
    Api,
    Ui,
    Service
}
